import React, { useState, useEffect } from 'react';
import HeroSection from '../components/HeroSection';

const Contact: React.FC = () => {
  const [contactContent, setContactContent] = useState<any>(null);

  useEffect(() => {
    fetch('/content/Contact.json')
      .then((response) => response.json())
      .then((data) => setContactContent(data))
      .catch((error) => console.error('Error loading JSON:', error));
  }, []);

  if (!contactContent) {
    return (
            <div className="flex items-center justify-center min-h-[50vh]">
                <div className="h-10 w-10 animate-spin rounded-full border-4 border-gray-300 border-t-logoPurple" />
            </div>
        );
  }

  const { heroSection, contactSection } = contactContent;

  return (
    <div>
      {/* Hero */}
      <HeroSection
        backgroundImage={heroSection.backgroundImage}
        headingText={heroSection.headingText}
        subHeadingText={heroSection.subHeadingText}
        heightSize={heroSection.heightSize}
        profileImage={heroSection.profileImage}
      />

      {/* Page content */}
      <div className="p-8">
        <div className="max-w-3xl mx-auto">
          {/* Section title */}
          <h1 className="text-center text-4xl font-bold text-logoPurple mb-6">
            {contactSection.sectionTitle}
          </h1>

          {/* Contact card */}
          <div className="bg-white rounded-lg shadow-lg p-6 space-y-4 text-gray-600">
            <p className="text-lg">
              <strong>LinkedIn:</strong>{' '}
              <a
                href={contactSection.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="text-logoPurple underline"
              >
                {contactSection.linkedin}
              </a>
            </p>

            <p className="text-lg">
              <strong>Email:</strong> {contactSection.email}
            </p>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
